import { Principal } from "./principal";

export class Product {
  code: string;
  estimate_price: number;
  estimate_stock: number;
  ims_class_1_code: string;
  ims_class_1_description: string;
  ims_class_2_code: string;
  ims_class_2_description: string;
  ims_class_3_code: string;
  ims_class_3_description: string;
  ims_class_4_code: string;
  ims_class_4_description: string;
  name: string;
  principal_id: string;
  principal_name: string;
  product_category: string;
  unit_of_measure: string;
  ref_quantity: number;
  description: string;
  dosage_description: string;
  usability_description: string;
  composition_description: string;
  how_to_use_description: string;
  image_url: string;
  image: {
    image_web: string,
    image_mobile: string
  };
  net_price: number;
  discount_list: any;
  display_net_price: boolean;
  label: string;
  max_show_discount: number;

  alert_message: string;
}

export class ProductSearchRequest {
  principal: Principal[] = [];
  class1: string = '';
  class2: string = '';
  class3: string = '';
  class4: string = '';
  src: string;
  lim: number = 10;
  off: number = 0;
}

export class AddToCartResponse {
  isSuccess: boolean;
  message: string;
  product: Product;
}

export class FirebaseParameter {
  code: string;
  event: string;
  value: any;
}

export const ListOfProducts: FirebaseParameter[] = [
  { code: 'siard50', event: 'siard50_ardium_500_tab_60s', value: 'siard50' },
  { code: 'azcres20', event: 'azcres20_crestor_20_mg_2x15tab', value: 'azcres20' },
  { code: 'azfrxg10', event: 'azfrxg10_forxiga_10_mg', value: 'azfrxg10' },
  { code: 'azcres10', event: 'azcres10_crestor_10_mg_2x15tab', value: 'azcres10' },
  { code: 'sidcmt60', event: 'sidcmt60_diamicron_mr_tab_60mg_30s_box', value: 'sidcmt60' },
  { code: 'aznxum40', event: 'aznxum40_nexium_40_mg', value: 1 },
  { code: 'aznxum20', event: 'aznxum20_nexium_20_mg', value: 2 },
  { code: 'eipr20s1', event: 'eipr20s1_pariet_20_mg_strip_new', value: 3 },
  { code: 'lbabx10', event: 'lbabx10_abixa_10_mg', value: 4 },
  { code: 'gxavns', event: 'gxavns_avamys_nasal_spray_btl_120spray', value: 5 },
  { code: 'mcne5000tn', event: 'mcne5000tn_neurobion_forte_ct_250s', value: 6 },
  { code: 'tuarc90', event: 'tuarc90_arcoxia_90mg_tab_30s', value: 7 },
  { code: 'msmet500', event: 'msmet500_janumet_50_500_mg_tablet_28s', value: 8 },
  { code: 'swpv28', event: 'swpv28_plavix_tablet_box_28s', value: 9 },
  { code: 'ymhrc30', event: 'ymhrc30_harnal_ocas_tab_30s', value: 10 },
  { code: 'ymfeb80', event: 'ymfeb80_feburic_tab_80mg', value: 11 },
  { code: 'svamrm2', event: 'svamrm2_amaryl_m_2_500_mg_30s', value: 12 },
  { code: 'sitrzdon1', event: 'sitrzdon1_trizedon_mr', value: 13 },
  { code: 'eimyl1', event: 'eimyl1_myonal_100_tab', value: 14 },
  { code: 'lbcip10', event: 'lbcip10_cipralex_10_mg', value: 15 },
  { code: 'lmciao5', event: 'lmciao5_cialis_oad_5_mg', value: 16 },
  { code: 'gxzt31', event: 'gxzt31_zyloric_tab_300_mg_100s_box', value: 17 },
  { code: 'svltss', event: 'svltss_lantus_solostar_5pen_box', value: 18 },
  { code: 'eimtc5', event: 'eimtc5_methycobal_500_mg_100_cap', value: 19 },
  { code: 'tuarc120', event: 'tuarc120_arcoxia_120mg_tab_30s', value: 20 }
];

